import { QuestionDetail } from "../type";
import { hasVisibleText } from "./htmlUtils";

export const getQuestionsToDisplay = (questions: QuestionDetail[] | undefined | null): QuestionDetail[] =>
    (questions ?? []).filter(q => {
        const hasExplanation = hasVisibleText(q.explanation);
        const hasStringAnswer = q.answerType === "STRING" && hasVisibleText(q.answer);
        return hasExplanation || hasStringAnswer;
    });

export const hasAnyExplanation = (questions: QuestionDetail[]): boolean =>
    questions.some(q => hasVisibleText(q.explanation));

export const shouldShowStringAnswer = (question: QuestionDetail): boolean =>
    question.answerType === "STRING" && hasVisibleText(question.answer);
